<template>
    <div class="change-data-wrapper">
        <el-table :data="data" stripe style="width: 100%" max-height="250" header-row-class-name="headerTable"
            :cell-style="{ padding: '8px 0' }">
            <el-table-column prop="status" label="类型" align="center" width="80">
                <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.status === 'change'" size="small">变更</el-tag>
                    <el-tag type="success" v-else-if="scope.row.status === 'add'" size="small">新增</el-tag>
                    <el-tag type="danger" v-else size="small">删除</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="hardDiskSize" label="硬盘大小" align="center">
                <template slot-scope="scope">
                    <span class="material-name">{{ scope.row.hardDiskSize || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="sampleCount" label="变更前数量" align="center">
                <template slot-scope="scope">
                    <span :class="{ 'value-changed': Number(scope.row.sampleCount) !== Number(scope.row.changeSampleCount) }">
                        {{ scope.row.sampleCount || '-' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="changeSampleCount" label="变更后数量" align="center">
                <template slot-scope="scope">
                    <span :class="{ 'value-changed': Number(scope.row.sampleCount) !== Number(scope.row.changeSampleCount) }">
                        {{ scope.row.changeSampleCount || '-' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="projectAmount" label="变更前项目金额" align="center">
                <template slot-scope="scope">
                    <span :class="{ 'value-changed': Number(scope.row.projectAmount) !== Number(scope.row.changeProjectAmount) }">
                        {{ scope.row.projectAmount || '-' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="changeProjectAmount" label="变更后项目金额" align="center">
                <template slot-scope="scope">
                    <span :class="{ 'value-changed': Number(scope.row.projectAmount) !== Number(scope.row.changeProjectAmount) }">
                        {{ scope.row.changeProjectAmount || '-' }}
                    </span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>

export default {
    name: "PurchaseChangeData",
    components: {},
    props: {
        oldData: {
            default: () => ([])
        },
        newData: {
            default: () => ([])
        },
    },
    data() {
        return {
            data: [],
            table: [],
            LexiconOptions: [],
            page: {
                pageSize: 10,
                currentNum: 1,
                total: null
            },
        }
    },
    computed: {
    },
    mounted() {
        this.getPurchaseData()
    },
    methods: {
        handlePagePagination(page) {
            this.page.currentNum = page.currentNum
            this.page.pageSize = page.pageSize
            this.getData()
        },
        getData() {
            this.page.total = this.table.length
            // 计算当前页的起始索引
            const startIndex = (this.page.currentNum - 1) * this.page.pageSize;
            // 返回当前页的数据
            this.data = this.table.slice(startIndex, startIndex + this.page.pageSize);
        },
        getPurchaseData() {
            try {
                const arr1 = [...this.oldData]
                const arr2 = [...this.newData]
                const map = new Map(arr1.map(item => [item.hardDiskSize, { ...item }]));
                arr2.forEach(item => {
                    if (map.has(item.hardDiskSize)) {
                        const existingItem = map.get(item.hardDiskSize);
                        map.set(item.hardDiskSize, {
                            hardDiskSize: item.hardDiskSize,
                            status: 'change',
                            projectAmount: existingItem.projectAmount,
                            changeProjectAmount: item.projectAmount,
                            sampleCount: existingItem.sampleCount,
                            changeSampleCount: item.sampleCount,
                        });
                    } else {
                        map.set(item.hardDiskSize, {
                            hardDiskSize: item.hardDiskSize,
                            projectAmount: '',
                            changeProjectAmount: item.projectAmount,
                            sampleCount: '',
                            changeSampleCount: item.sampleCount,
                            status: 'add',
                        });
                    }
                });
                arr1.forEach(item => {
                    if (!arr2.map(item => item.hardDiskSize).includes(item.hardDiskSize)) {
                        map.set(item.hardDiskSize, {
                            hardDiskSize: item.hardDiskSize,
                            projectAmount: item.projectAmount,
                            changeProjectAmount: '',
                            sampleCount: item.sampleCount,
                            changeSampleCount: '',
                            status: 'delete'
                        });
                    }
                });
                this.table = Array.from(map.values())
                this.getData()
            } catch (error) {
                console.log(error);
            }
        }
    }
}
</script>

<style scoped lang="scss">
.change-data-wrapper {
    ::v-deep .headerTable th {
        background-color: #f5f7fa;
        font-weight: 600;
        color: #303133;
    }
}

.material-name {
    font-weight: 500;
    color: #409eff;
}

.value-changed {
    color: #f56c6c;
    font-weight: 500;
}

.empty-data {
    text-align: center;
    padding: 20px;
    color: #909399;
}
</style>
